import DTConfirmation from '../DTConfirmationView/DTConfirmation';

const ConfirmLastMileReplacementOrder = () => {
  return <DTConfirmation message={"The customer's replacement order has been scheduled."} />;
};

export default ConfirmLastMileReplacementOrder;
